import styles from "./AlasanIkut.module.css"
import { Col } from "antd"
import VerifiedIcon from "./assets/Verified-icon.svg"

const data = [
  "Sertifikat Pelatihan Resmi & Diakui oleh Mitra Industri",
  "Materi Up To Date, Lengkap, dan Mudah Dipahami",
  "Silabus Materi disesuaikan dengan SKKNI",
  "Trainer yang Berpengalaman di Bidangnya",
  "Metode Pembelajaran yang Interaktif",
  "Akses Konsultasi Seumur Hidup",
  "Terdapat Studi Kasus",
]

const AlasanIkut = () => {
  return (
    <>
      <div className={`container ${styles.body}`}>
        <Col span={7} className="description" data-aos="fade-up">
          <h1 className={styles.header}>
            Kenapa Harus <br /> Mindo Education?
          </h1>
          <p className={styles.desc}>
            Berbagai nilai tambah yang dapat <br /> diperoleh melalui kerja sama
            dan <br />
            kemitraan yang strategis
          </p>
        </Col>
        <Col span={14} className={styles.wrapper} data-aos="fade-up">
          {data.map((text, i) => (
            <div key={i} className={styles.list}>
              <img src={VerifiedIcon} alt="" />
              <h5
                className={styles.listContent}
                dangerouslySetInnerHTML={{
                  __html: text.replace("Up To Date", "<i>Up To Date</i>"),
                }}
              />
            </div>
          ))}
        </Col>
      </div>
    </>
  )
}

export default AlasanIkut
